import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import { ArchivedButton } from '../shared/archivedButton';
import { QuestionList } from '../questionList/questionList';

interface Question {
  key: string;
  prompt: string;
  flag?: string;
  [key: string]: any;
}

interface FillInBlankQuestionsProps {
  basePath: string;
  questions: Question[];
  showCreateButton?: boolean;
  sortQuestions?: boolean;
}

export const FillInBlankQuestions: React.FC<FillInBlankQuestionsProps> = ({
  basePath,
  questions,
  showCreateButton = false,
  sortQuestions = false
}) => {
  const [showOnlyArchived, setShowOnlyArchived] = useState(false);

  const toggleShowArchived = () => {
    setShowOnlyArchived(!showOnlyArchived);
  };

  const sortedQuestions = sortQuestions
    ? [...questions].sort((a, b) => a.prompt.localeCompare(b.prompt))
    : questions;

  return (
    <section className="section">
      <div className={showCreateButton ? "admin-container" : "container"}>
        {showCreateButton && (
          <Link className="button is-primary" to={`/admin/${basePath}/new`}>Create a New Fill In The Blank</Link>
        )}
        <ArchivedButton
          lessons={false}
          showOnlyArchived={showOnlyArchived}
          toggleShowArchived={toggleShowArchived}
        />
        <p className="menu-label">Fill In The Blank</p>
        <QuestionList
          basePath={basePath}
          questions={sortedQuestions}
          showOnlyArchived={showOnlyArchived}
        />
      </div>
    </section>
  );
};
